import { render } from "./InspectorDashboard.vue?vue&type=template&id=4f683114&scoped=true&ts=true"
import script from "./InspectorDashboard.vue?vue&type=script&lang=ts"
export * from "./InspectorDashboard.vue?vue&type=script&lang=ts"

import "./InspectorDashboard.vue?vue&type=style&index=0&id=4f683114&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f683114"]])

export default __exports__